import React, { useState, useEffect } from "react";

import { useContext } from "react";
import { CustomFilters, FilterActions } from "../FiltersData";
import { HomeContext, FilterContext } from "../../Context";
// import { getDisableFlag } from "../../Common/Functions";

// import { selectedPolygonTypes } from "../../Common/Constants";
import { Button } from "antd";

// const { demographicPopulationDensity } = selectedPolygonTypes;
function ApplyFilters() {
	// eslint-disable-next-line
	let [applyFilterLoading, setapplyFilterLoading] = useState(false);

	const { FilterShops, selectedPolygons, tenant, censusFilterKey } = useContext(HomeContext);
	const { state, dispatch } = useContext(FilterContext);

	useEffect(() => {
		const key = `${tenant}-${selectedPolygons}`;
		const fallbackKey = `${tenant}-${censusFilterKey}`;
		const filtersToLoad = CustomFilters?.[key] ?? CustomFilters?.[fallbackKey];

		if (!filtersToLoad) return;

		dispatch({
			type: FilterActions.loadFilter,
			value: { filters: filtersToLoad }
		});

		(async () => {
			setapplyFilterLoading(true);
			try {
				await FilterShops(filtersToLoad);
			} finally {
				setapplyFilterLoading(false);
			}
		})();
	}, [tenant, selectedPolygons, censusFilterKey, CustomFilters, dispatch]);

	return (
		<>
			<Button
				className="blueclr "
				// loading={applyFilterLoading}
				// disabled={applyFilterLoading || getDisableFlag(selectedPolygons)}
				onClick={async () => {
					let filters = structuredClone(state);

					setapplyFilterLoading(true);
					await FilterShops(filters, selectedPolygons, tenant);
					setapplyFilterLoading(false);
				}}
			>
				Apply
			</Button>
		</>
	);
}

export default React.memo(ApplyFilters);
